export function stripHtml(html) {
  if (!html) return '';
  return html.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim();
}

export function getFeaturedImageUrl(post) {
  if (!post) return null;

  const jetpackUrl = post.jetpack_featured_media_url;
  const media = post?._embedded?.['wp:featuredmedia']?.[0];

  if (media?.code || media?.data?.status >= 400) {
    return jetpackUrl || extractFirstImageFromContent(post?.content?.rendered) || null;
  }

  const fromMedia =
    media?.source_url ||
    media?.media_details?.sizes?.medium_large?.source_url ||
    media?.media_details?.sizes?.large?.source_url ||
    media?.media_details?.sizes?.medium?.source_url ||
    media?.guid?.rendered;

  return fromMedia || jetpackUrl || extractFirstImageFromContent(post?.content?.rendered) || null;
}

function extractFirstImageFromContent(html) {
  if (!html) return null;
  const match = html.match(/<img[^>]+src=["']([^"']+)["']/i);
  if (!match?.[1]) return null;
  return match[1].replace(/&amp;/g, '&');
}

export function normalizePost(post, siteBase) {
  const image = getFeaturedImageUrl(post);
  const cleanExcerpt = stripHtml(post?.excerpt?.rendered || '').slice(0, 160);
  const title = stripHtml(post?.title?.rendered || 'Untitled post');
  const date = post?.date
    ? new Date(post.date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      })
    : '';
  const link = post?.slug
    ? `${siteBase}/blog/${post.slug}`
    : `${siteBase}/blog/${post.id}`;

  return {
    id: post.id,
    title,
    excerpt: cleanExcerpt,
    date,
    link,
    image,
  };
}
